import React, { useEffect, useLayoutEffect, useRef } from 'react'

export default function useUrlSearch() {

    const search = useRef(null)

    useEffect(() => {
        let params = (new URL(document.location)).searchParams;
        search.current = params;
    }, [document.location.href])

    const getByKey = (key) => search.current.get(key)

    return {
        getByKey
    }

}
